import { useDispatch, useSelector } from 'react-redux'
import InputDateRange from '../../../common/datePicker/InputDateRange'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Radio } from '../../../common/html/radio'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import {
  FORMAT,
  formatDateTime,
  getCurrentDateTime,
  getDateTimeFrom,
} from '../../../helpers/datetime'
import { changeFilter, selectFilter } from '../store/slice'
import classes from './index.module.scss'

export const RadioDateRange = ({ value, activeValue }) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()
  const startDate = useSelector(selectFilter('startDate'))
  const endDate = useSelector(selectFilter('endDate'))

  const isActive = value === activeValue

  const onSubmit = ({ startDate, endDate }) => {
    dispatch(changeFilter({ timePeriod: value, startDate, endDate, page: 1 }))
  }

  return (
    <InputDateRange
      defaultStartDate={
        isActive ? startDate : getDateTimeFrom(new Date(), -7, 'days')
      }
      defaultEndDate={isActive ? endDate : getCurrentDateTime()}
      maxDate={getCurrentDateTime()}
      minDate={getDateTimeFrom(new Date(), -1, 'years')}
      onSubmit={onSubmit}
    >
      <Radio
        title={
          <Element
            className={classes.dateRange}
            style={{ backgroundColor: '#FFFFFF', color: '#9C9C9C' }}
          >
            <TextEllipsisStaticLine
              appendStyle={{ color: isActive ? '#191d25' : '#9C9C9C' }}
              lineClamp={1}
              text={
                !isActive
                  ? 'alerts.timePeriod.CUSTOM'
                  : `${formatDateTime(
                      startDate,
                      FORMAT.DATE,
                      locale,
                      timezone,
                    )} > ${formatDateTime(
                      endDate,
                      FORMAT.DATE,
                      locale,
                      timezone,
                    )}`
              }
              isI18n={!isActive}
            />
            <Icon
              className="icon-calendar"
              style={{ fontSize: 16, color: '#9C9C9C' }}
            />
          </Element>
        }
        isI18n={false}
        titleStyle={{ flex: 1, minWidth: 0 }}
        value={value}
        activeValue={activeValue}
        stopPropagation={false}
        appendStyle={{ marginTop: 8 }}
      />
    </InputDateRange>
  )
}
